import { forwardRef, HTMLAttributes } from 'react'

import { useTheme } from '@/contexts/theme'

import { cn } from '@/lib/utils'

export type ContainerProps = HTMLAttributes<HTMLDivElement>

const Container = forwardRef<HTMLDivElement, ContainerProps>(({ className, ...props }, ref) => {
  const { fluid } = useTheme()

  return (
    <div ref={ref} className={cn('container', { 'max-w-full': fluid }, className)} {...props} />
  )
})

export default Container
